import { Component, OnInit, Input } from '@angular/core';
import { WorkerCareService } from '../../service/worker-care/worker-care.service';
import { WorkerCare } from '../../class/worker-care';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';


@Component({
  selector: 'app-worker-cares',
  templateUrl: './worker-cares.component.html',
  styleUrls: ['./worker-cares.component.scss']
})
export class WorkerCaresComponent implements OnInit {
    @Input() gestionSac: any;

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public workerCares: WorkerCare[];
    public selectWorkerCare: WorkerCare;
    public workerCareID: Number = 0;
    public modNew = false;
    public modView = false;
    public openWorkerCare = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public loading: boolean;

    public pagePath: string;
    public subPagePath: string;

    public showFilter: boolean;
    public myEmployeeId: string;
    public filters: {key: string, value: string}[];
    public verification: boolean;
    public showNew: boolean;
    public params_id_worker_care: number;
    //public reloadInterval: any;

    public form3: FormGroup;
    public company_id_filter: AbstractControl;
    public created_by_id_filter: AbstractControl;
    public candidate_id_filter: AbstractControl;

    public first = 0;

    public modExportDialog: boolean;
    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public apiUrl = config.API_ROOT;

    public modViewDialogUploadWorkerCares: boolean = false;
    public loading_upload: boolean = false;
    public workerCaresUploadResult: any;
    public workerCaresUploadResultStatus : number=0;
    public lengthWorkerCaresUploadResult : number=0;


    public es: any;

    constructor(
        public workerCareService: WorkerCareService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        private route: ActivatedRoute,
        public activatedRoute: ActivatedRoute,
        public fb: FormBuilder,
        public uploadFilesService: UploadFilesService,
        ) { 
            this.es = calendarES();            

            this.form3 = fb.group({
                'company_id_filter': [''],
                'created_by_id_filter': [''],
                'candidate_id_filter': ['']
            });
            this.company_id_filter = this.form3.controls['company_id_filter'];
            this.created_by_id_filter = this.form3.controls['created_by_id_filter'];
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];

    
            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];

            this.modExportDialog = false;
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';

        if (this.route.snapshot.url[1].path !== 'gestionSACs') {
            this.pagePath = this.route.snapshot.url[1].path;
            this.subPagePath = this.route.snapshot.url[2].path;
            this.showFilter = true;
        } else {
            this.pagePath = 'worker-cares';
            this.subPagePath = 'worker-cares-reported';
            this.showFilter = false;
        }

        this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

        this.filters = [];
        if (this.gestionSac) {
            this.filters.push({key: 'gestion_sac_id-in', value: this.gestionSac.id});
            this.showNew = true;
        } else {
            switch (this.pagePath) {
                case 'worker-cares':
                    switch (this.subPagePath) {
                        case 'worker-cares-reported':
                            this.filters.push({key: 'executive_id-in', value: this.myEmployeeId});
                            this.verification = false;
                            this.showNew = true;
                        break;
                        case 'worker-cares-asigned':
                            if (this.hasPermission('get pqr Sistemas')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Gerencia')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '2'});
                            } else if (this.hasPermission('get pqr Comercial')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '3'});
                            } else if (this.hasPermission('get pqr Nómina')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '4'});
                            } else if (this.hasPermission('get pqr Suministros')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '5'});
                            } else if (this.hasPermission('get pqr Servicio al Cliente')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '6'});
                            } else if (this.hasPermission('get pqr HSE')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '7'});
                            } else if (this.hasPermission('get pqr Contratación')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '8'});
                            } else if (this.hasPermission('get pqr Contabilidad')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '9'});
                            } else if (this.hasPermission('get pqr Selección')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '10'});
                            } else if (this.hasPermission('get pqr Calidad')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '11'});
                            } else if (this.hasPermission('get pqr Sercontratos')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '12'});
                            } else if (this.hasPermission('get pqr Gestión Humana')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '13'});
                            } else if (this.hasPermission('get pqr Gestión de Pagos')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '14'});
                            } else if (this.hasPermission('get pqr Medellín')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '17'});
                            } else if (this.hasPermission('get pqr Barranquilla')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '20'});
                            } else if (this.hasPermission('get pqr Cali')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '26'});
                            } else if (this.hasPermission('get pqr Bucaramanga')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '24'});
                            } else if (this.hasPermission('get pqr Buga')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '27'});
                            } else if (this.hasPermission('get pqr Jurídica')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '25'});
                            } else if (this.hasPermission('get pqr Seguridad Social')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '45'});
                            }  
                            else {
                                this.filters.push({key: 'person_receiving_id-in', value: this.myEmployeeId});
                            }

                            this.verification = false;
                            this.showNew = false;
                        break;
                        case 'worker-cares-verification':
                            this.verification = true;
                            this.showNew = false;
                        break;
                    }
                break;
            }
        }

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_worker_care']) {
                this.params_id_worker_care = Number(params['id_worker_care']);
                const filters = [];
                filters.push({key: 'id-in', value: String(this.params_id_worker_care)});
                this.getWorkerCareById(this.query, filters);
            } //else {
                //this.getWorkerCares();
            //}
        });

        // this.reloadInterval = setInterval(() => {
        //     this.getWorkerCares();
        // }, 10000);
        //this.getWorkerCares();
    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        // clearInterval(this.reloadInterval);
    }

    public loadWorkerCaresLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            if (event.sortField) {
                this.sort =  event.sortField;
            } else {
                this.sort = '-id';
            }
        }


        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';


        if (event.globalFilter) {
            this.query = event.globalFilter;
        }
        this.getWorkerCares();
    }

    public getWorkerCares() {
        this.workerCareService.getWorkerCare(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.workerCares = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newWorkerCare() {
        this.modNew = !this.modNew;
        this.selectWorkerCare = null;
    }

    public savedWorkerCare(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectWorkerCare = null;
        this.modNew = false;
        // this.getWorkerCares();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelWorkerCare (res) {
        this.selectWorkerCare = null;
        this.modNew = false;
        this.modView = false;
        // this.getWorkerCares();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(workerCare: WorkerCare) {
        this.modNew = true;
        this.selectWorkerCare = workerCare;
        // this.getWorkerCares();
    }

    public view(workerCare: WorkerCare) {
        this.openWorkerCare = true;
        this.selectWorkerCare = workerCare;
        this.workerCareID = workerCare.id;
        this.modView = true;
    }

    public deleteDialog(workerCare: WorkerCare) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(workerCare);
            }
        });
    }

    public delete(workerCare: WorkerCare) {
        this.workerCareService.deleteWorkerCare(workerCare.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getWorkerCares();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeWorkerCare(workerCare: WorkerCare) {
        this.putWorkerCare(workerCare);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public hasRole(rol){
        var r: boolean=false; 
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){ 
            r = true;
        }
        return (r);
    }
    
    public putWorkerCare(values: WorkerCare) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.workerCareService.updateWorkerCare(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    getWorkerCareById(query?: string, filters?: any[]) {
        this.loading = true;
        this.workerCareService.getWorkerCare(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.loading = false;
                this.edit(response.json().data[0]);
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/worker-cares/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        window.open(url, '_blank');
    }    

    public filter (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (this.gestionSac) {
            this.filters.push({key: 'gestion_sac_id-in', value: this.gestionSac.id});
        }
        if (values.company_id_filter) {
            this.filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});
        }
        if (values.created_by_id_filter) {
            this.filters.push({'key': 'created_by_id-lk', 'value': values.created_by_id_filter.id});
        }
        if (values.candidate_id_filter) {
            this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});
        }

        switch (this.pagePath) {
            case 'worker-cares':
                switch (this.subPagePath) {
                    case 'worker-cares-reported':
                        this.filters.push({key: 'executive_id-in', value: this.myEmployeeId});
                        this.verification = false;
                        this.showNew = true;
                    break;
                    case 'worker-cares-asigned':
                        if (this.hasPermission('get pqr Sistemas')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '1'});
                        } else if (this.hasPermission('get pqr Gerencia')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '2'});
                        } else if (this.hasPermission('get pqr Comercial')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '3'});
                        } else if (this.hasPermission('get pqr Nómina')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '4'});
                        } else if (this.hasPermission('get pqr Suministros')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '5'});
                        } else if (this.hasPermission('get pqr Servicio al Cliente')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '6'});
                        } else if (this.hasPermission('get pqr HSE')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '7'});
                        } else if (this.hasPermission('get pqr Contratación')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '8'});
                        } else if (this.hasPermission('get pqr Contabilidad')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '9'});
                        } else if (this.hasPermission('get pqr Selección')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '10'});
                        } else if (this.hasPermission('get pqr Calidad')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '11'});
                        } else if (this.hasPermission('get pqr Sercontratos')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '12'});
                        } else if (this.hasPermission('get pqr Gestión Humana')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '13'});
                        } else if (this.hasPermission('get pqr Gestión de Pagos')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '14'});
                        } else if (this.hasPermission('get pqr Medellín')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '17'});
                        } else if (this.hasPermission('get pqr Barranquilla')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '20'});
                        } else if (this.hasPermission('get pqr Cali')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '26'});
                        } else if (this.hasPermission('get pqr Bucaramanga')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '24'});
                        } else if (this.hasPermission('get pqr Buga')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '27'});
                        } else if (this.hasPermission('get pqr Jurídica')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '25'});
                        } else if (this.hasPermission('get pqr Seguridad Social')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '45'});
                        }  
                        else {
                            this.filters.push({key: 'person_receiving_id-in', value: this.myEmployeeId});
                        }

                        this.verification = false;
                        this.showNew = false;
                    break;
                    case 'worker-cares-verification':
                        this.verification = true;
                        this.showNew = false;
                    break;
                }
            break;
        }

        this.getWorkerCares();
    }
    public showUploadDialog() {
        this.modViewDialogUploadWorkerCares = true;
    }
    
    public cancelUpload() {
        this.modViewDialogUploadWorkerCares = false;
        //this.filter();
        // this.requisitionTrasnferOk=false;
        // this.requisitionTrasnfer=[];
        // this.resultSelectworkerCaresTransf=[];
        // this.lengthresultSelectWorkerCaresTransf=0;
        // this.showrequisitionTransfer=false;
    }
    public attachmentUploadWorkerCares(event) {
        this.loading_upload=true;
        // this.translate.get('uploading').subscribe((res: string) => {
        //     this.notificationsService.growlNotify('info', res + '...');
        // });
        // this.translate.get('uploading').subscribe((res: string) => {
        //     this.msgs = [];
        //     this.msgs.push( { severity: 'info', summary: res  } );
        // });
        this.translate.get('uploading').subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push( { severity: 'info', summary: res  } );
        });
        
        let uploadedAttachment = [];
        for (const file of event.files) {
            uploadedAttachment.push(file);
        }
            
        this.uploadFilesService.attachmentUploadWorkerCares(uploadedAttachment).toPromise().then(
            response => {
                this.loading_upload=false;
                this.workerCaresUploadResult=response.json().data;
                this.workerCaresUploadResultStatus =response.status;
                this.lengthWorkerCaresUploadResult= this.workerCaresUploadResult.length;
                console.log("Documento subido excel");
                // this.translate.get('saved').subscribe((res: string) => {
                //     this.notificationsService.growlNotify('success', res);
                // });
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
            },
            error => {
                this.loading_upload=false;
                let msg = '';
                this.workerCaresUploadResult = error._body;
                this.workerCaresUploadResultStatus = error.status;
                this.lengthWorkerCaresUploadResult= 0;
                this.msgs = [];
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        // this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        
                        this.msgs.push( { severity: 'error', summary: res1 + ' ' + res2+' '+msg } );
                    });
                });
                
            }
        );
    }
    public downloadTemplateWorkerCares()
    {
        window.open(this.apiUrl + '/worker-cares/downloadTemplateWorkerCare'+ '?token=' + localStorage.getItem('token'));
    }    
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/worker-care/worker-cares.component.ts